import { render, staticRenderFns } from "./PageFilter.vue?vue&type=template&id=6047918a&scoped=true&"
import script from "./PageFilter.vue?vue&type=script&lang=js&"
export * from "./PageFilter.vue?vue&type=script&lang=js&"
import style0 from "./PageFilter.vue?vue&type=style&index=0&id=6047918a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047918a",
  null
  
)

export default component.exports